// extracted by mini-css-extract-plugin
export default {"root":"PropertyInspectActivationModal_root__zYUGs"};